/**
 * Validation for the optional publish directory submitted with a git
 * connection. The value is appended to `deploys/current` on the app server
 * when the website's document root is pointed at the build output, so it
 * must be a relative POSIX-style path that cannot escape the website's home
 * directory. Empty values are valid and mean "not set".
 */
export const validatePublishDirectory = (value?: string): boolean => {
  if (value === undefined || value === null || value === '') {
    return true;
  }

  if (value.startsWith('/') || value.includes('\\') || value.includes('\0')) {
    return false;
  }

  return !value.split('/').some((part) => part === '.' || part === '..');
};

export const publishDirectoryErrorMessage = 'Publish directory must be a relative path without "../"';

/**
 * Normalises the raw form value before it is sent to the API: an empty (or
 * whitespace-only) string is reported as "not set", and surrounding
 * whitespace as well as any trailing slashes are removed.
 */
export const normalisePublishDirectory = (value?: string): string | undefined => {
  if (!value) {
    return undefined;
  }

  const trimmed = value.trim().replace(/\/+$/, '');

  return trimmed === '' ? undefined : trimmed;
};
